// extracted by css-extract-rspack-plugin
export default {"budgetSidebarRoot":"AqZTXX","content":"LkJ8yR","balances":"_w0kxm","navList":"OdGq40","badgeRight":"uQyYyW","navItem":"BtDKKs"};